import script from "./LbrxCategoryBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LbrxCategoryBar.vue?vue&type=script&setup=true&lang=ts"

import "./LbrxCategoryBar.vue?vue&type=style&index=0&id=af222758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af222758"]])

export default __exports__